import { Avatar, Box, Divider, IconButton, Link, Stack, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { AttachFile, CancelOutlined, ChatBubbleOutlineOutlined, CommentOutlined, DocumentScannerOutlined, KeyboardVoice, PaymentsOutlined, PlaylistRemoveOutlined, Send, BoltOutlined } from '@mui/icons-material';
import CustomTextField from '../../common/CustomTextField';
import { fetchPaymentNotesById, getPaymentById, PaymentNotes, resetPaymentById, resetPaymentNotes, uploadPaymentNotes, usePaymentSlice, voidPayment } from '../../../redux/slice/payment/paymentSlice';
import { useAppDispatch } from '../../../redux/slice/redux-hooks';
import { convertBase64, hideElement, priceFormatter } from '../../../utils/Utility';
import { useForm } from 'react-hook-form';
import { setSingleAlertObj, SingleAlertInfo } from '../../../redux/slice/commonSlice';
import { useLocation } from 'react-router-dom';
import PDFViewer from '../../common/pdf/PDFViewer';
import { fetchOrderDocumentsByIds, useOrderSlice } from '../../../redux/slice/order/OrderSlice';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { selectIsValueFoundInToken } from '../../../redux/slice/authSlice';
import { PAYMENT_ACTIONS, PAYMENT_STATUS } from '../../../constants/applicationConstants';
import Button from '../../common/Button';
import PageBackButton from '../../common/PageBackButton';
import { SUCCESS_CODE } from '../../../service/ServiceConstants';
import { useNavigation } from '../../../hooks/useNavigation';
import OptionsPopup, { OptionPopupObjectProps } from '../../common/OptionsPopup';
import SpeechToTextPopup from '../../common/SpeechToTextPopup';
import { getCommissionListByPaymentId } from '../../../redux/slice/commission/commissionSlice';
import InfoPopup from '../../common/InfoPopup';
import CustomIconButton from '../../common/CustomIconButton';
import CustomCommentPopup from '../../common/CustomCommentPopup';
import { formatMethodLabel } from './PaymentList';
import { SectionHeader } from '../../ui/ContentSection';
import { useModalStyles } from '../../common/useModalStyles';

//CS-1512 - Rendering payment status color
   export const renderPaymentStatusColor = (status:string|undefined) => {
        if (status === PAYMENT_STATUS.VOID || status === PAYMENT_STATUS.FAILED || status === PAYMENT_STATUS.CANCELLED) {
            return  "#e4192aff";
        } else if (status === PAYMENT_STATUS.RECEIVED) {
            return "#28a745";
        } else {
            return "warning";
        }
    };

const PaymentDetails = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { navigate } = useNavigation();
    const { paymentNotesList, paymentById } = usePaymentSlice();
    const userSideMap: Record<string, boolean> = {};
    let lastAuditUserName: string | null = null;
    const [selectedFileName, setSelectedFileName] = useState<string | null>(null);
    const { handleSubmit, setValue, control } = useForm<PaymentNotes>();
    const [pdfContent, setPDFContent] = useState<string>("");
    const [showPDF, setShowPDF] = useState<{ isShow: boolean, productName: string, fileName: string }>({ isShow: false, productName: "", fileName: "" })
    const { orderDocumentInfo } = useOrderSlice();
    const canAccessVoidPayment = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPaymentActions", PAYMENT_ACTIONS.VOID)(state));
    const [showOptionPopup, setShowOptionsPopup] = useState<OptionPopupObjectProps>({ message: '', show: false });
    const [isVoicePopupOpen, setIsVoicePopupOpen] = useState(false);
      const [showInfoPopup, setShowInfoPopup] = useState<{message: string;title: string;show: boolean;}>({ message: "", title: "", show: false });
      //CS-1512 - added failure reason in popup
      const [failureReasonData, setFailureReasonData] = useState<{ title: string; body: string }>({ title: "", body: "" });
      const [showReasonPopup, setShowReasonPopup] = useState(false);
    const {
      tokens: mTokens,
      isDark: isDarkModal,
    } = useModalStyles();
    const cardSx = {
      borderRadius: "16px",
      border: `1px solid ${mTokens.border}`,
      backgroundColor: mTokens.bg,
      backgroundImage: "none",
      overflow: "hidden" as const,
      boxShadow: isDarkModal ? "0 10px 20px rgba(0,0,0,0.1)" : "none",
    };
    const outlineAccentBtnSx = {
      textTransform: "none" as const,
      fontWeight: 700,
      fontSize: "0.82rem",
      borderRadius: "10px",
      height: 36,
      px: 1.6,
      color: "#F59E0B",
      borderColor: "#F59E0B",
      backgroundColor: "transparent",
      whiteSpace: "nowrap" as const,
      letterSpacing: "0.04em",
      "&:hover": {
        backgroundColor: "rgba(245,158,11,0.12)",
        borderColor: "#F59E0B",
        boxShadow: "none",
      },
      "& .MuiTypography-root": { color: "#F59E0B !important" },
      "& .MuiButton-startIcon, & .MuiButton-endIcon": { color: "#F59E0B" },
    };

    const InfoRow = ({ label, value }: { label: string; value?: React.ReactNode }) => (
      <Box display="flex" alignItems="center" py={1.15} sx={{ borderBottom: `1px solid ${mTokens.border}`, "&:last-child": { borderBottom: "none" } }}>
        <Typography sx={{ fontSize: "0.82rem", color: mTokens.textSecondary, width: "45%", flexShrink: 0 }}>
          {label}
        </Typography>
        <Typography sx={{ fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 600, flex: 1 }} component="div">
          {value ?? "—"}
        </Typography>
      </Box>
    );
    
    useEffect(() => {
        const paymentId = location.state?.paymentId;
        if (paymentId) {
            setValue("xrefId", paymentId);
            dispatch(fetchPaymentNotesById(paymentId));
            dispatch(getPaymentById(paymentId));
        };
        resetData();
    }, []);

      //Unmount
      useEffect(() => () => {
        dispatch(resetPaymentNotes());
        dispatch(resetPaymentById());
      }, []);

    const handleActionPreview = async (row: any, type: string) => {
        const documentId = type === "note" ? row.attachementId : row.documentId;
        if (documentId) {
            const actionResult = await dispatch(
                fetchOrderDocumentsByIds(documentId)
            );
            const documentData = actionResult.payload;
            if (documentData && documentData.content) {

                setPDFContent(documentData.content);
                console.log("documentData", documentData);
                console.log("pdfContent", pdfContent);
                setShowPDF({
                    isShow: true,
                    productName: "Invoice - " + row.auditUserName,
                    fileName: documentData.documentName,
                });
            } else {
                dispatch(
                    setSingleAlertObj({
                        message: "Requested Document has not found under server location!",
                        alertType: "info",
                    })
                );
            }
        }
    };

    const removeDataUriPrefix = (dataUri: string): string => {
        const base64String = dataUri.split(",")[1];
        return base64String || "";
    };

    const handleNotDocumentFileChange = async (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        try {
            const files = event.target.files;
            if (files && files.length > 0) {
                const file = files[0];
                const base64File = await convertBase64(file);

                setValue("attachment", removeDataUriPrefix(String(base64File)));
                setValue("documentName", file.name);
                setValue("fileType", file.type);
                setValue("noteType", "PAYMENT ADDITIONAL NOTE");
                setValue("xrefTable", "PAYMENT");
                setSelectedFileName(file.name);
            } else {
                console.error("No files selected or invalid input.");
            }
        } catch (error) {
            console.error("Error processing the file:", error);
        }
    };

    const handleRemoveFile = () => {
        setSelectedFileName(null);
        setValue("attachment", "");
    };

    const resetData = () => {
        setValue("attachment", "");
        setValue("xrefTable", "PAYMENT");
        setValue("noteType", "PAYMENT ADDITIONAL NOTE");
        setValue("content", "");
        handleRemoveFile();
    };

    const onSubmit = async (data: PaymentNotes) => {
        setValue("xrefId", location.state?.paymentId.toString());
        try {
            const response = await dispatch(uploadPaymentNotes(data));
            if (
                response.payload &&
                response.payload.message === "Note is added successfully"
            ) {
                let alertMessage = "Note saved Successfully!";
                const alertObj: SingleAlertInfo = {
                    message: alertMessage,
                    alertType: "success",
                };
                dispatch(setSingleAlertObj(alertObj));
                dispatch(fetchPaymentNotesById(location.state?.paymentId));
                resetData();
            }
        } catch (error) {
            console.log("Error saving note:", error);
        }
    };

    const confirmVoidPayment = async (paymentId: number) => {

        const commissionListResponse = await dispatch(getCommissionListByPaymentId(paymentId));
        if (commissionListResponse?.payload && commissionListResponse.payload?.code === SUCCESS_CODE) {
            const commData = commissionListResponse.payload.data;
            if (commData?.length > 0) {
                setShowInfoPopup({
                    message: "This payment includes V3 Revenues or Agency Service Fees that have been paid.",
                    title: "Warning",
                    show: true,
                });
            } else {
                setShowOptionsPopup({
                    message: `Are you sure you want to void this payment record?`,
                    show: true,
                    variant: "confirm",
                    buttons: [{ name: "Confirm", color: 'primary', onClick: () => onVoidPayment(paymentId) }, { name: "Cancel", color: 'secondary', onClick: cancelOptionPopup }]
                });
            }
        }
    };

    const cancelOptionPopup = () => {
        setShowOptionsPopup({ message: "", show: false });
    };

    const onVoidPayment = async (paymentId: number) => {
        const response = await dispatch(voidPayment(paymentId));
        if (response?.payload?.code === SUCCESS_CODE) {
            const alertObj: SingleAlertInfo = {
                message: "Payment void successful",
                alertType: "success",
            };
            dispatch(setSingleAlertObj(alertObj));
            navigate("/payment_list", { state: { withSearchHistory: true } });
        } else {
            const alertObj: SingleAlertInfo = {
                message: "Something went wrong",
                alertType: "error",
            };
            dispatch(setSingleAlertObj(alertObj));
        }
    }

    //CS-1512 - added failure reason popup
    const showFailureReasonPopup = (data:any) => {
    const title = "Failure Reason";
    const body = data.paymentErrorReason;
    setFailureReasonData({ title, body });
    setShowReasonPopup(true);
  };
    
    // Show cancellation reason popup
    const showCancellationReasonPopup = (data:any) => {
    const title = "Cancellation Reason";
    const body = data.paymentErrorReason;
    setFailureReasonData({ title, body });
    setShowReasonPopup(true);
  };
    
    const hideReasonPopup = () => {
    setShowReasonPopup(false);
  };

    return (
        <>
        {/* CS-1512 - added failure reason popup */}
            {showReasonPopup && (
                <CustomCommentPopup
                    open={showReasonPopup}
                    onClose={hideReasonPopup}
                    title={failureReasonData.title}
                    commentBody={failureReasonData.body}
                />
            )}
            {showPDF && <PDFViewer
                isOpen={showPDF.isShow}
                onClose={() => setShowPDF({ isShow: false, productName: "", fileName: "" })}
                title={showPDF.productName}
                fileName={showPDF.fileName}
                base64String={orderDocumentInfo?.content || ""}
            />}

            {showOptionPopup.show &&
                <OptionsPopup
                    open={showOptionPopup.show}
                    onClose={() => setShowOptionsPopup({ message: "", show: false })}
                    variant={showOptionPopup.variant}
                    message={<>{showOptionPopup.message}</>}
                    buttons={showOptionPopup.buttons}
                    title={showOptionPopup.title}
                    obj={showOptionPopup.obj}
                />
            }
            {isVoicePopupOpen && (
                <SpeechToTextPopup
                    open={isVoicePopupOpen}
                    onClose={() => { setIsVoicePopupOpen(false) }}
                    onSubmitVoice={(data: any) => setValue("content", data)}
                />
            )}

            {showInfoPopup.show && (
                <InfoPopup
                    open={showInfoPopup.show}
                    onClose={() => { setShowInfoPopup({ message: "", title: "", show: false }); }}
                    content={showInfoPopup.message}
                    severity="warning"
                    title={showInfoPopup.title}
                    onConfirm={() => { setShowInfoPopup({ message: "", title: "", show: false }); }}
                />
            )}

            <Box
              sx={{
                mx: { xs: "10px", sm: "20px" },
                mt: "12px",
                pb: "72px",
              }}
            >
                <Box mb={2} display="flex" alignItems="flex-start" justifyContent="space-between" gap={1.5} flexWrap="wrap">
                  <Box display="flex" alignItems="flex-start" gap={1.5}>
                    <PageBackButton tooltip={null} />
                    <Box data-testid="mock-header">
                      <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: mTokens.textSecondary, textTransform: "uppercase", letterSpacing: "0.12em", mb: 0.3 }}>
                        Payment / Payment Detail
                      </Typography>
                      <Typography sx={{ fontSize: "1.6rem", fontWeight: 800, color: mTokens.textPrimary, lineHeight: 1.1 }}>
                        Payment Detail
                      </Typography>
                    </Box>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                    {canAccessVoidPayment && (
                      <Button
                        variant="outlined"
                        removeUpperCase
                        onClick={() => paymentById?.paymentId && confirmVoidPayment(paymentById.paymentId)}
                        style={{ display: `${hideElement(paymentById?.paymentStatus !== PAYMENT_STATUS.RECEIVED)}` }}
                        startIcon={<PlaylistRemoveOutlined fontSize="small" />}
                        sx={outlineAccentBtnSx}
                      >
                        Void
                      </Button>
                    )}
                  </Box>
                </Box>

                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1.4fr 1fr" }, gap: 2, alignItems: "flex-start" }}>
                  <Box sx={{ ...cardSx, order: { xs: 2, md: 1 } }}>
                    <SectionHeader icon={<ChatBubbleOutlineOutlined fontSize="small" />} title="Notes" />
                    <Box
                      sx={{
                        maxHeight: "400px",
                        overflowY: "auto",
                        borderTop: `1px solid ${mTokens.border}`,
                        borderBottom: `1px solid ${mTokens.border}`,
                      }}
                    >
                      {paymentNotesList?.map((note: any, index: number) => {
                        if (!(note.auditUserName in userSideMap)) {
                          userSideMap[note.auditUserName] =
                            lastAuditUserName === null ||
                            !userSideMap[lastAuditUserName];
                        }
                        const isLeft = userSideMap[note.auditUserName];
                        lastAuditUserName = note.auditUserName;

                        return (
                          <Box
                            key={index}
                            display="flex"
                            justifyContent={isLeft ? "flex-start" : "flex-end"}
                            p={2}
                          >
                            {isLeft && (
                              <Avatar
                                sx={{
                                  marginRight: 1,
                                  fontSize: 20,
                                  fontWeight: "bold",
                                  backgroundColor: mTokens.accent,
                                }}
                              >
                                {note.auditUserName.charAt(0)}
                              </Avatar>
                            )}
                            <Box
                              sx={{
                                padding: 1.4,
                                backgroundColor: isDarkModal ? "#1c252e" : mTokens.headerFooterBg,
                                minWidth: "30%",
                                maxWidth: "100%",
                                borderRadius: isLeft
                                  ? "1px 10px 10px 10px"
                                  : "10px 1px 10px 10px",
                                border: `1px solid ${mTokens.border}`,
                              }}
                            >
                              <Typography sx={{ fontSize: "0.82rem", fontWeight: 700, color: mTokens.textPrimary }}>
                                {note.auditUserName}
                              </Typography>
                              <Typography sx={{ fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 600, mt: 1 }}>
                                {note.content}
                              </Typography>

                              {note.attachementId && (
                                <Stack
                                  alignItems="center"
                                  direction="row"
                                  gap={1}
                                  onClick={() => handleActionPreview(note, "note")}
                                  mt={1}
                                  sx={{ cursor: "pointer", color: mTokens.accent }}
                                >
                                  <Typography sx={{ fontSize: "0.85rem", fontWeight: 700 }}>
                                    {note.documentName}
                                  </Typography>
                                  <Tooltip title="View File" placement="top" arrow>
                                    <Box display="flex">
                                      <DocumentScannerOutlined sx={{ fontSize: 22 }} />
                                    </Box>
                                  </Tooltip>
                                </Stack>
                              )}
                              <Box display="flex" justifyContent="flex-end">
                                <Typography sx={{ fontSize: "0.7rem", color: mTokens.textSecondary, mt: 0.5 }}>
                                  {note.auditTimestamp}
                                </Typography>
                              </Box>
                            </Box>

                            {!isLeft && (
                              <Avatar
                                sx={{
                                  marginLeft: 1,
                                  fontSize: 20,
                                  fontWeight: "bold",
                                }}
                              >
                                {note.auditUserName.charAt(0)}
                              </Avatar>
                            )}
                          </Box>
                        );
                      })}
                    </Box>
                    <Divider sx={{ borderColor: mTokens.border }} />
                    <Box
                      sx={{
                        p: 2,
                        backgroundColor: mTokens.headerFooterBg,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.75,
                          px: 1,
                          py: 0.5,
                          minHeight: 44,
                          borderRadius: "12px",
                          border: `1px solid ${mTokens.border}`,
                          backgroundColor: mTokens.bg,
                        }}
                      >
                          <Tooltip title="Speech to text" placement="top" arrow>
                            <IconButton
                              color="default"
                              component="label"
                              sx={{
                                width: 36,
                                height: 36,
                                p: 0,
                                borderRadius: "10px",
                                bgcolor: mTokens.accent,
                                transition: "background-color 0.4s ease",
                                flexShrink: 0,
                                "&:hover": {
                                  bgcolor: "#0d9488",
                                },
                              }}
                              onClick={() => setIsVoicePopupOpen(true)}
                            >
                              <KeyboardVoice sx={{ color: "#ffffff", fontSize: "1.15rem" }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Attach File" placement="top" arrow>
                            <IconButton
                              color="default"
                              component="label"
                              sx={{
                                width: 36,
                                height: 36,
                                p: 0,
                                borderRadius: "10px",
                                border: `1px solid ${mTokens.border}`,
                                backgroundColor: mTokens.headerFooterBg,
                                color: mTokens.textSecondary,
                                flexShrink: 0,
                                "&:hover": {
                                  borderColor: mTokens.accent,
                                  color: mTokens.accent,
                                  backgroundColor: `${mTokens.accent}0d`,
                                },
                              }}
                            >
                              <AttachFile sx={{ fontSize: "1.15rem" }} />
                              <input
                                type="file"
                                hidden
                                onChange={handleNotDocumentFileChange}
                              />
                            </IconButton>
                          </Tooltip>
                          <Box
                            sx={{
                              flex: 1,
                              minWidth: 0,
                              display: "flex",
                              alignItems: "center",
                              "& .MuiFormControl-root": { m: 0, width: "100%" },
                              "& .MuiInputBase-root.MuiInputBase-multiline": {
                                padding: "0 !important",
                              },
                              "& .MuiOutlinedInput-root": {
                                alignItems: "center",
                                minHeight: "36px !important",
                                padding: "0 !important",
                                backgroundColor: "transparent !important",
                                boxShadow: "none !important",
                                borderRadius: "8px !important",
                              },
                              "& .MuiOutlinedInput-root fieldset, & .MuiOutlinedInput-notchedOutline": {
                                border: "none !important",
                              },
                              "& .MuiInputLabel-root, & label": { display: "none" },
                              "& .MuiOutlinedInput-root textarea, & .MuiInputBase-inputMultiline": {
                                boxSizing: "border-box !important",
                                minHeight: "36px !important",
                                height: "auto !important",
                                maxHeight: "96px !important",
                                padding: "8px 10px !important",
                                lineHeight: "20px !important",
                                fontSize: "0.88rem",
                                color: mTokens.textPrimary,
                                resize: "none",
                                overflowY: "auto",
                              },
                            }}
                          >
                            <CustomTextField
                              controllerName="content"
                              control={control}
                              label=""
                              placeholder="Write a note..."
                              multiline
                              minRows={1}
                              maxRows={4}
                              size="small"
                              rules={{ required: "Notes are required." }}
                              inputProps={{ "aria-label": "Notes" }}
                            />
                          </Box>
                          <IconButton
                            sx={{
                              width: 36,
                              height: 36,
                              p: 0,
                              mb: 0,
                              borderRadius: "10px",
                              backgroundColor: mTokens.accent,
                              flexShrink: 0,
                              "&:hover": {
                                backgroundColor: "#0d9488",
                              },
                            }}
                            onClick={handleSubmit(onSubmit)}
                          >
                            <Send sx={{ color: "#ffffff", fontSize: "1.15rem" }} />
                          </IconButton>
                      </Box>
                        {selectedFileName && (
                          <Box
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              mt: 1.2,
                              px: 1.2,
                              py: 0.6,
                              borderRadius: "999px",
                              border: `1px solid ${mTokens.accent}55`,
                              backgroundColor: `${mTokens.accent}14`,
                              color: mTokens.accent,
                              maxWidth: "100%",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                fontStyle: "italic",
                                mr: 0.5,
                                color: mTokens.textPrimary,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {selectedFileName}
                            </Typography>
                            <IconButton
                              size="small"
                              onClick={handleRemoveFile}
                              sx={{
                                color: mTokens.error,
                              }}
                            >
                              <CancelOutlined fontSize="small" />
                            </IconButton>
                          </Box>
                        )}
                    </Box>
                  </Box>

                  <Box sx={{ ...cardSx, order: { xs: 1, md: 2 } }}>
                    <SectionHeader icon={<PaymentsOutlined fontSize="small" />} title="Payment Info" />
                    <Box sx={{ px: 2.8, py: 1.5 }}>
                      <InfoRow
                        label="Invoice"
                        value={
                          <Box display="flex" alignItems="center" gap={1}>
                            <Link
                              component="button"
                              underline="hover"
                              variant="body2"
                              onClick={(e) => {
                                e.stopPropagation()
                                navigate("/invoice_list", { state: { mfgInvoiceNumber: paymentById?.invoiceNumber } });
                              }}
                              sx={{ color: mTokens.accent, fontWeight: 600, fontSize: "0.88rem" }}
                            >
                              {paymentById?.invoiceNumber || '-'}
                            </Link>
                            {paymentById?.isUpfrontOrder && (
                              <BoltOutlined
                                sx={{ fontSize: 20, color: "#00E5B0" }}
                                titleAccess="Upfront Payment"
                              />
                            )}
                          </Box>
                        }
                      />
                      <InfoRow label="MFG" value={paymentById?.manufacturerName || '-'} />
                      <InfoRow label="Practice" value={paymentById?.practiceName || '-'} />
                      <InfoRow
                        label="Pay Method"
                        value={paymentById ? paymentById.paymentMethod === "us_bank_account" ? "ACH" : formatMethodLabel(paymentById.paymentMethod) : '-'}
                      />
                      <InfoRow label="Transaction ID" value={paymentById?.transactionId || '-'} />
                      <InfoRow
                        label="Payment Amount"
                        value={paymentById?.paymentAmount && priceFormatter(parseFloat(paymentById.paymentAmount)) || '-'}
                      />
                      {paymentById?.platformFee !== null && (
                        <InfoRow
                          label="Stripe Platform Fee"
                          value={paymentById?.platformFee && priceFormatter(parseFloat(paymentById.platformFee)) || '-'}
                        />
                      )}
                      <InfoRow
                        label="Paid Amount"
                        value={paymentById?.totalPaidAmount && priceFormatter(parseFloat(paymentById.totalPaidAmount)) || '-'}
                      />
                      <InfoRow label="Pay Type" value={paymentById?.paymentType || '-'} />
                      <InfoRow
                        label="Status"
                        value={
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography sx={{ fontSize: "0.88rem", fontWeight: 600, color: renderPaymentStatusColor(paymentById?.paymentStatus) }}>
                              {paymentById?.paymentStatus || '-'}
                            </Typography>
                            {paymentById?.paymentStatus === PAYMENT_STATUS.FAILED && (
                              <CustomIconButton
                                tooltipPlacement="top"
                                tooltipMessage="Failed Reason"
                                color="info"
                                size="small"
                                variant="outlined"
                                onClick={() => showFailureReasonPopup(paymentById)}
                              >
                                <CommentOutlined fontSize="small" />
                              </CustomIconButton>
                            )}
                            {paymentById?.paymentStatus === PAYMENT_STATUS.CANCELLED && (
                              <CustomIconButton
                                tooltipPlacement="top"
                                tooltipMessage="Cancellation Reason"
                                color="info"
                                size="small"
                                variant="outlined"
                                onClick={() => showCancellationReasonPopup(paymentById)}
                              >
                                <CommentOutlined fontSize="small" />
                              </CustomIconButton>
                            )}
                          </Box>
                        }
                      />
                      <InfoRow
                        label="Pay Date"
                        value={
                          <Typography sx={{ fontSize: "0.88rem", fontWeight: 600, color: renderPaymentStatusColor(paymentById?.paymentStatus) }}>
                            {paymentById?.paymentDate || '-'}
                          </Typography>
                        }
                      />
                    </Box>
                  </Box>
                </Box>
            </Box>
        </>
    )
}

export default PaymentDetails
